import React, { useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { PDFDownloadLink } from '@react-pdf/renderer';
import { isDateMoreThanXDaysFromToday, DEADLINE_DAYS } from "../../../utils/timeConverter";
import ListPdfDocument from "./ListPdfDocument";
import AveryPdfDocument from "./AveryPdfDocument";
import { GET_SIGNUPS_FOR_MENU_ITEM } from "../gql/queries";

const CountInfo = ({ menu, showAll, pickupGroup, isExpanded: isExpandedProp, onExpand }) => {
    const [isExpandedLocal, setIsExpandedLocal] = useState(false);
    const [getSignupsForMenu, { loading, data: getPdfListData }] = useLazyQuery(GET_SIGNUPS_FOR_MENU_ITEM, { variables: { menuId: "" } });

    const isExpanded = onExpand ? isExpandedProp : isExpandedLocal;

    const fetchMenuList = async () => {
        if (onExpand) {
            onExpand();
        } else {
            setIsExpandedLocal(true);
        }
        await getSignupsForMenu({
            variables: { menuId: menu._id }
        });
    };

    const hasValidData = (data) => {
        if (data === null) {
            return false;
        }
        if (data.getSignupsForMenuItem === undefined || data.getSignupsForMenuItem.length === 0) {
            return false;
        }
        return true;
    };

    const fileNameGenerator = (menu) => {
        let epoch = parseFloat(menu.menuDate);
        return menu.dish.dishName.replace(/ /g, '') + "-" + new Date(epoch).toLocaleDateString('en-US');
    }

    const getCsvHeaders = () => {
        return [
            { label: "Name", key: "name" },
            { label: "Day", key: "day" },
            { label: "Size", key: "size" },
            { label: "Zone", key: "zone" },
            { label: "Dish", key: "dish" },
        ];
    }

    const convertToCsvDataForAvery = (signupData, pickupGroup) => {
        if (pickupGroup) {
            const userIds = [];
            pickupGroup.users.forEach(user => userIds.push(user._id));
            return signupData
                .filter(signup => userIds.includes(signup.user._id))
                .map(signup => {
                    const date = new Date(parseFloat(signup.menuItem.menuDate));
                    return {
                        name: signup.user.fullName,
                        day: date.toLocaleDateString('en-US', { weekday: 'long' }) + ' ' + 
                             date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
                        size: signup.size,
                        zone: signup.user.zone,
                        dish: signup.menuItem.dish.dishName,
                        menuItemId: signup.menuItem._id
                    }
                })
        }
        return signupData.map(signup => {
            const date = new Date(parseFloat(signup.menuItem.menuDate));
            return {
                name: signup.user.fullName,
                day: date.toLocaleDateString('en-US', { weekday: 'long' }) + ' ' + 
                     date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
                size: signup.size,
                zone: signup.user.zone,
                dish: signup.menuItem.dish.dishName,
                menuItemId: signup.menuItem._id
            }
        })
    }

    const filterGroup = (data, pickupGroup) => {
        if (pickupGroup) {
            const userIds = [];
            pickupGroup.users.forEach(user => userIds.push(user._id));
            return userIds.length > 0 ? data.getSignupsForMenuItem
                .filter(signup => userIds.includes(signup.user._id)) : data.getSignupsForMenuItem;
        } else {
            return data.getSignupsForMenuItem;
        }
    }

    const getCountForSize = (data, pickupGroup, size) => {
        if (pickupGroup) {
            const userIds = [];
            pickupGroup.users.forEach(user => userIds.push(user._id));
            return data.getSignupsForMenuItem
                .filter(signup => userIds.includes(signup.user._id))
                .filter(signup => signup.size === size).length;
        }
        return data.getSignupsForMenuItem.filter(signup => signup.size === size).length;
    }

    return (
        <div id={"form" + menu._id} className="generateBtnForm">
            {!isExpanded && (
                <div id={"button" + menu._id} className="generateBtn">
                    <button id={menu._id} className="generateButtons" onClick={fetchMenuList}>Counts</button>
                </div>
            )}
            {isExpanded && (
                <div id={"countAndLinkInfo" + menu._id} className="generateDiv" style={{ display: 'flex' }}>
                    {getPdfListData && hasValidData(getPdfListData) &&
                        <>
                            <p>Large:&nbsp;&nbsp;<b>{getCountForSize(getPdfListData, pickupGroup, 'Large')}</b></p>
                            <p>Small:&nbsp;&nbsp;<b>{getCountForSize(getPdfListData, pickupGroup, 'Small')}</b></p>
                        </>
                    }
                    {
                        !isDateMoreThanXDaysFromToday(menu?.menuDate, DEADLINE_DAYS) &&
                        <>
                            {
                                getPdfListData && hasValidData(getPdfListData) &&
                                filterGroup(getPdfListData, pickupGroup).length > 0 &&
                                <PDFDownloadLink
                                    document={<ListPdfDocument
                                        signupsForMenuItem={filterGroup(getPdfListData, pickupGroup)} />}
                                    fileName={"List-" + fileNameGenerator(menu) + ".pdf"}
                                    className="csvLink">List</PDFDownloadLink>
                            }
                            {
                                getPdfListData && hasValidData(getPdfListData) &&
                                filterGroup(getPdfListData, pickupGroup).length > 0 &&
                                <PDFDownloadLink
                                    document={<AveryPdfDocument
                                        labelData={convertToCsvDataForAvery(getPdfListData.getSignupsForMenuItem, pickupGroup)} />}
                                    fileName={"Labels-" + fileNameGenerator(menu) + ".pdf"}
                                    className="csvLink">Labels</PDFDownloadLink>
                            }
                        </>
                    }
                </div>
            )}
        </div>
    )
}

export default CountInfo;
